
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#20253A","opacity":".4"}},[_c('path',{attrs:{"d":"M30.814 31.81a1.166 1.166 0 00-.48-1.243 18.65 18.65 0 01-8.107-14.017 1.166 1.166 0 00-1.362-1.064 8.96 8.96 0 00-4.352 2.047 1.167 1.167 0 01-1.526 0 9.014 9.014 0 00-5.922-2.203C3.983 15.328 0 20.137 0 26.273a18.2 18.2 0 003.696 11.868 1.166 1.166 0 01.2 1.127 26.917 26.917 0 00-1.467 8.88c-.002 1.899.19 3.792.572 5.652A2.77 2.77 0 005.703 56a2.826 2.826 0 002.814-2.522c.6-5.49 3.708-9.63 7.233-9.63 3.526 0 6.634 4.14 7.233 9.632A2.826 2.826 0 0025.797 56a2.77 2.77 0 002.703-2.2c.382-1.86.573-3.753.571-5.652a26.907 26.907 0 00-1.468-8.88 1.167 1.167 0 01.196-1.125 15.75 15.75 0 003.015-6.333zM40.833 0A15.167 15.167 0 1056 15.167 15.185 15.185 0 0040.833 0zm4.126 15.993l3.357 3.357a2.335 2.335 0 01-1.641 4.012 2.333 2.333 0 01-1.658-.712l-3.358-3.358a1.169 1.169 0 00-1.652 0L36.65 22.65a2.334 2.334 0 01-3.3-3.3l3.358-3.357a1.166 1.166 0 000-1.652l-3.358-3.358a2.333 2.333 0 013.3-3.3l3.357 3.358a1.165 1.165 0 001.652 0l3.358-3.357a2.335 2.335 0 014.011 1.64 2.333 2.333 0 01-.712 1.659l-3.358 3.358a1.168 1.168 0 000 1.652z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h56v56H0z"}})])])])
          )
        }
      }
    